import React from 'react';

export function LeaderboardIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M32 22V6H16v12H4v24h40V22H32zM20 10h8v28h-8V10zM8 22h8v16H8V22zm32 16h-8V26h8v12z" />
    </svg>
  );
}
